import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class ShowWinningState extends BaseState {
    constructor(stateData) {
        super(stateData);

        this.timeout = null;
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('bigWinContainer:stopState', this.stopNow, this);
    }

    stopNow() {
        this.stop();
    }

    /*start() {
        super.start();
        this.timeout = setTimeout(()=>{
            this.complete();
        },15000);
    }

    onEnd() {
        super.onEnd();
        clearTimeout(this.timeout);
    }*/
}